export function handleAccordions() {
    $("body").on('click', '.js-accordion-btn', function () {
        $(this).closest($(".js-accordion-wrap")).toggleClass("accordion--active");
    });
}